import React from 'react';
import './NotFound.scss';
import {Link} from 'react-router-dom';
import routes from '../../common/routes/routes'

const NotFound = () => {
    return (
        <div className="NotFound">
            <h1 className="NotFound__title">Страница не найдена</h1>
            <Link href={routes.MAIN} className="NotFound__link" >Вернуться на главную</Link>
        </div>
    )
}

export default NotFound
